import React from 'react';
import styled from 'styled-components';
import EllipsesControl from '../../../../Common/EllipsesControl/EllipsesControl';
import {labels, currentResource} from '../../../../../util/utils';
import {WIDTH_55, WIDTH_45} from '../../../../../util/uiconstants';
import Icon from '../../../../Common/BaseComponentWrappers/MotifIcon';
import {IconoirCustomRiskBolt} from '@ey/motif-react-wrapper/assets/icons/custom';

const ManageObjects = {
	Header: (props) => {
		const {title} = props;

		return (
			<>
				<section className="instructionalText">
					<span className="relate-list__header__instructional-text">
						<EllipsesControl
							content={labels.fsro_instructionalText}
							tooltip={labels.fsro_instructionalText}
							noOfLines={1}
						/>
					</span>
				</section>
				<section className="RelatedTasksDocument">
					<section className="DocumentNameWrapper">
						<h3>
							<EllipsesControl
								content={title}
								tooltip={title}
								noOfLines={2}
								tooltipClass="tooltipCustomWidth"
								width={(window.innerWidth * WIDTH_45) / 100}
							/>
						</h3>
					</section>
				</section>
			</>
		);
	},
	RenderItem: (props) => {
		const {item, className, renderSvg, noOfLines} = props;

		return (
			<>
				{item.riskTypeId !== null && item.riskTypeId !== undefined && (
					<section className="RiskRelatedIcon">
						<Icon className="small" size="16" src={IconoirCustomRiskBolt} title={labels.boltIconTitle} />
						<span className="RiskRelatedIconText">{currentResource.riskTypes[item.riskTypeId - 1].abbrev}</span>
					</section>
				)}
				<span className={className}>
					<EllipsesControl
						content={item.name}
						tooltip={item.name}
						noOfLines={noOfLines}
						tooltipClass="tooltipCustomWidth"
						width={(window.innerWidth * WIDTH_55) / 100}
					/>
				</span>
				{renderSvg && <span className="custom-icon">{renderSvg(item)}</span>}
			</>
		);
	},
	ListHeader: (props) => {
		const {className, count, countLabel} = props;

		return (
			<StyledEditRelatedObject className={`relate-list-header--${className}`}>
				<span className={`relatedObjectText relate-list-header__item-label--${className}`}>{labels.objectName}</span>
				{count && count > 0 ? (
					<span className={`relate-list-header__counter--${className}`}>
						{countLabel && countLabel.replace('{0}', count)}
					</span>
				) : (
					''
				)}
			</StyledEditRelatedObject>
		);
	}
};

const StyledEditRelatedObject = styled.section`
	display: flex;
	width: 100%;
	.relatedObjectText {
		display: inline-flex;
		font-size: var(--px-14);
		margin-right: auto;
		color: var(--neutrals-900);
		font-weight: 700;
	}
	.relate-list-header__counter--generic-entity {
		font-size: var(--px-14);
		margin-bottom: var(--px-10);
		color: var(--neutrals-900);
		font-weight: 700;
	}
	.relatedObjectWrapper {
		display: inline-flex;
		margin-bottom: var(--px-10);
	}
	.relatedObjectHeading {
		display: flex;
		align-items: center;
		width: var(--px-40);
		margin-right: var(--px-10);
		svg {
			padding: var(--px-3);
			fill: var(--neutrals-700);
		}
		.wcgwCount {
			font-size: var(--px-12);
			color: var(--neutrals-700);
		}
	}
	.reletedObjectEditControls {
		display: flex;
		.reletedObjectEditControlIcon {
			display: inline-flex;
			align-items: center;
		}
		.motif-icon {
			display: flex;
			align-items: center;
			svg {
				fill: var(--neutrals-700);
				width: var(--px-22) !important;
				height: var(--px-22) !important;
			}
		}
		.controlCount {
			font-size: var(--px-12);
			color: var(--neutrals-700);
		}
	}
`;

export default ManageObjects;
